import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {resetALL} from "Redux/actions";
import {clientMutation} from "Core/data/GraphQLApi";
import {endpoints} from "Core/defaultValues";
import {ExceptionManager} from "Core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    loadingCreate: false
};

const route = 'modules/driverPerformance/views/cases/modals/createPanel/redux/slice';

const bulkCreateDriverPerformanceCasesFull = createAsyncThunk(
    "driverPerformance/casesTab/createPanel/bulkCreateDriverPerformanceCasesFull",
    async (payload, {rejectWithValue, getState}) => {
        try {
            const response = await clientMutation(
                bulkCreateDriverPerformanceCasesFull.query,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            if (!response?.data) {
                throw 'bulkCreateDriverPerformanceCasesFull : No data found';
            }

            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "bulkCreateDriverPerformanceCasesFull");
            return rejectWithValue(exc);
        }
    }
);

bulkCreateDriverPerformanceCasesFull.query = `
    mutation bulkCreateDriverPerformanceCasesFull ($driverScope: Int!, $limitedBy: Int!, $eventCategories: Int!, $eventsLimit: Int!, $includeHighlight: Boolean!) {
        data: bulkCreateDriverPerformanceCasesFull (driverScope: $driverScope, limitedBy: $limitedBy, eventCategories: $eventCategories, eventsLimit: $eventsLimit, includeHighlight: $includeHighlight) {
            stepFunctionId
            transactionId
            transactionType
            processStartDate
        }
    }`;

export {bulkCreateDriverPerformanceCasesFull};

//Slice
const driverPerformanceCasesTabCreatePanelRedux = createSlice({
    name: "driverPerformance/createPanel",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? {...state, ...action.payload} : INIT_STATE;
        },
        openModalCreatePanel: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(bulkCreateDriverPerformanceCasesFull.pending, (state) => {
            state.loadingCreate = true;
            state.error = null;
        });
        builder.addCase(bulkCreateDriverPerformanceCasesFull.fulfilled, (state, action) => {
            state.loadingCreate = false;
            state.coaches = action.payload;
        });
        builder.addCase(bulkCreateDriverPerformanceCasesFull.rejected, (state, action) => {
            state.loadingCreate = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const {actions, reducer} = driverPerformanceCasesTabCreatePanelRedux;

// Extract and export each action creator by name
export const {openModalCreatePanel, reset} = actions;

// Export the reducer, either as a default or named export
export default reducer;
